// extracted by mini-css-extract-plugin
export default {"teaserContainer":"Q4EZhv9bpUn3uGrIWiiT","teaserTitle":"btc5ZV2sb8iovHjhT3x1","teaserTokenList":"ZVJ3GQ1OjtgKyhh_Qp3a","copyIconBtn":"Y5jdjRNzqarCsN0XPbRq"};